import React from "react";

const integrations = [
  { name: "Trusted By 500+ Bussiness" },
  { name: "ISO 27001 Ready" },
  { name: "Bank-Grade Security" },
  { name: "GDPR Compliant" },
   { name: "PCI DSS AOC" }
];

const Integrations = () => {
  return (
    <section className="py-16 bg-white border-b-2 border-[#f4f4f4]">
      <div className="container mx-auto px-4">

        {/* Integrations List */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {integrations.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-3 bg-[#D9F4EF] text-[#0F766E] text-center justify-center px-5 py-3 rounded-lg font-medium text-sm"
            > <span>{item.name}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Integrations;
